// ─── Finance-specific SUI Hooks ──────────────────────────────────────────
import { useSuiClientQuery, useCurrentAccount } from '@mysten/dapp-kit';
import { AGU_TOKEN_TYPE, AGU_DECIMALS, OBJECTS } from './constants';

export function useAGUBalance() {
  const account = useCurrentAccount();
  const { data, isLoading, error, refetch } = useSuiClientQuery(
    'getBalance',
    { owner: account?.address ?? '', coinType: AGU_TOKEN_TYPE },
    { enabled: !!account?.address },
  );
  const raw = BigInt((data as any)?.totalBalance ?? '0');
  const balance = Number(raw) / 10 ** AGU_DECIMALS;
  return { balance, rawBalance: raw, isLoading, error, refetch, address: account?.address };
}

export function useStakingPool() {
  const { data, isLoading, error, refetch } = useSuiClientQuery(
    'getObject',
    { id: OBJECTS.stakingPool, options: { showContent: true } },
  );
  let info = { totalStaked: '0', rewardRate: 0, stakerCount: 0 };
  const obj = data as any;
  if (obj?.data?.content?.dataType === 'moveObject') {
    const f = obj.data.content.fields;
    if (f) {
      info = {
        totalStaked: f.total_staked || '0',
        rewardRate: Number(f.reward_rate_bps || 0) / 100,
        stakerCount: Number(f.staker_count || 0),
      };
    }
  }
  return { info, isLoading, error, refetch };
}

export function useSettlementTreasury() {
  const { data, isLoading, error, refetch } = useSuiClientQuery(
    'getObject',
    { id: OBJECTS.settlementTreasury, options: { showContent: true } },
  );
  let info = { totalLocked: '0', totalSettled: '0', escrowCount: 0 };
  const obj = data as any;
  if (obj?.data?.content?.dataType === 'moveObject') {
    const f = obj.data.content.fields;
    if (f) {
      info = {
        totalLocked: f.total_locked || '0',
        totalSettled: f.total_settled || '0',
        escrowCount: Number(f.escrow_count || 0),
      };
    }
  }
  return { info, isLoading, error, refetch };
}

export function useGovernanceInfo() {
  const { data, isLoading, error, refetch } = useSuiClientQuery(
    'getObject',
    { id: OBJECTS.governanceConfig, options: { showContent: true } },
  );
  let info = { proposalCount: 0, quorumThreshold: 0, votingPeriod: 0 };
  const obj = data as any;
  if (obj?.data?.content?.dataType === 'moveObject') {
    const f = obj.data.content.fields;
    if (f) {
      info = {
        proposalCount: Number(f.proposal_count || 0),
        quorumThreshold: Number(f.quorum_threshold || 0),
        votingPeriod: Number(f.voting_period_ms || 0),
      };
    }
  }
  return { info, isLoading, error, refetch };
}
